import { VersionUpdateBanner } from '@components/common/VersionUpdateBanner';
import { LocalizationContext } from '@localization/LocalizationContext/LocalizationContext';
import { Router } from '@router/Router';
import { PosthogProvider } from '@providers/PosthogProvider/PosthogProvider';
import { AuthProvider } from '@providers/AuthProvider/AuthContext';
import { ApiInterceptorProvider } from '@providers/ApiInterceptorProvider/ApiInterceptorProvider';
import { TanstackQueryProvider } from '@providers/TanstackQueryProvider';
import { SnackbarProvider } from '@providers/SnackbarProvider/SnackbarProvider';
import { AntdProvider } from '@providers/AntdProvider/AntdProvider';
export const App = () => {
  return (
    <PosthogProvider>
      <AuthProvider>
        <ApiInterceptorProvider>
          <TanstackQueryProvider>
            <LocalizationContext>
              <SnackbarProvider>
                <AntdProvider>
                  <VersionUpdateBanner />
                  <Router />
                </AntdProvider>
              </SnackbarProvider>
            </LocalizationContext>
          </TanstackQueryProvider>
        </ApiInterceptorProvider>
      </AuthProvider>
    </PosthogProvider>
  );
};
